import { isWithinInterval } from "date-fns"
import React from "react"
import withVisibility from "../Hocs/withVisibility/withVisibility"

type AutoHideComponentProps = {
	children: React.ReactNode | undefined
	start: Date
	end: Date
}

const AutoHide: React.FC<AutoHideComponentProps> = (props) => {
	const { children, start, end } = props
	const today = new Date()
	const interval = { start, end }
	const todayIsInRange = isWithinInterval(today, interval)

	return todayIsInRange ? <>{children}</> : null
}

export default withVisibility(AutoHide)
